import React, { useState } from "react";
import "./MiceTravel.css";

const galleryImages = [
  "/Images/tour/mice/gallery1.webp",
  "/Images/tour/mice/gallery2.png",
  "/Images/tour/mice/gallery3.webp",
  "/Images/tour/mice/gallery4.jpeg",
  "/Images/tour/mice/gallery5.jpeg",
  "/Images/tour/mice/gallery6.png",
  "/Images/tour/mice/gallery7.jpeg",
  "/Images/tour/mice/gallery8.webp",
  "/Images/tour/mice/gallery9.jpg",
  "/Images/tour/mice/gallery10.webp",
  "/Images/tour/mice/gallery11.JPG",
  "/Images/tour/mice/gallery12.webp",
];

const MiceGallery = () => {

  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section className="mice-full-gallery">

      <div className="gallery-header">
        <h2>MICE Event Gallery</h2>
        <p>
          Explore our corporate events, conferences, incentive tours,
          exhibitions and premium MICE experiences executed worldwide.
        </p>
      </div>

      {/* GALLERY GRID */}
      <div className="modal-gallery-grid">
        {galleryImages.map((img, i) => (
          <div
            className="gallery-card"
            key={i}
            onClick={() => setSelectedImage(img)}
          >
            <img src={img} alt={`MICE Event ${i}`} />
          </div>
        ))}
      </div>

      {/* IMAGE POPUP MODAL */}
      {selectedImage && (
        <div
          className="image-modal"
          onClick={() => setSelectedImage(null)}
        >
          <span
            className="close-btn"
            onClick={() => setSelectedImage(null)}
          >
            ✕
          </span>

          <img
            src={selectedImage}
            alt="Preview"
            className="modal-image"
          />
        </div>
      )}

    </section>
  );
};

export default MiceGallery; 